/**
 * 平台类型定义
 */
export enum PlatformEnum {
  /** Web环境 */
  Web = 'Web',
  /** Liteapp环境 */
  LiteApp = 'LiteApp',
  /** 小程序环境 */
  Miniprogram = 'Miniprogram',
}

/**
 * 环境信息接口
 */
export interface EnvironmentInfo {
  /** 平台类型 */
  platformType: PlatformEnum;
  /** 是否为移动端 */
  isMobile: boolean;
  /** 是否支持触摸 */
  isTouch: boolean;
  /** 是否在浏览器环境 */
  inBrowser: boolean;
}

/**
 * 平台能力信息
 */
export interface PlatformCapabilities {
  /** 是否支持localStorage */
  localStorage: boolean;
  /** 是否支持fetch */
  fetch: boolean;
  /** 是否支持requestAnimationFrame */
  requestAnimationFrame: boolean;
  /** 是否支持addEventListener */
  addEventListener: boolean;
  /** 是否支持scroll事件 */
  scrollEvents: boolean;
  /** 是否支持resize事件 */
  resizeEvents: boolean;
}

/**
 * 平台信息接口
 */
export interface PlatformInfo {
  /** 环境信息 */
  env: EnvironmentInfo;
  /** 平台能力 */
  capabilities: PlatformCapabilities;
  /** 平台版本 */
  version?: string;
}

/**
 * 错误信息接口
 */
export interface PlatformError {
  /** 错误类型 */
  type: 'api_not_supported' | 'api_failed' | 'fallback_used';
  /** 错误消息 */
  message: string;
  /** 原始错误 */
  originalError?: Error;
  /** 发生错误的API名称 */
  apiName?: string;
  /** 平台类型 */
  platformType: PlatformEnum;
}

/**
 * 降级配置接口
 */
export interface FallbackConfig {
  /** 是否启用降级 */
  enabled: boolean;
  /** 降级时的默认值 */
  defaults: {
    viewportSize: { width: number; height: number };
    userAgent: string;
  };
  /** 是否在降级时输出警告 */
  warnOnFallback: boolean;
}
